import { useMemo } from "react";

import { useProjectInfo } from "../../ducks/project/hooks";
import { isConfigure, isWrite } from "../../utils/permissions";

export const useIsProjectEditable = (): boolean => {
  const [project] = useProjectInfo();

  return useMemo(() => {
    return project && (isWrite(project.permissions) || isConfigure(project.permissions));
  }, [project]);
};
